import React from "react";
import usePlacesAutocomplete, {
  getGeocode,
  getLatLng,
} from "use-places-autocomplete";
import {
  Combobox,
  ComboboxInput,
  ComboboxList,
  ComboboxOption,
  ComboboxPopover,
} from "@reach/combobox";
import "@reach/combobox/styles.css";
import SearchButton from "./SearchButton";

const MapSearch = ({
  loaded,
  panTo,
  setSelected,
  setShowMenu,
  setShowSearch,
  showSearch,
}) => {
  const {
    ready,
    value,
    suggestions: { status, data },
    setValue,
    clearSuggestions,
  } = usePlacesAutocomplete();

  const handleChange = (event) => {
    setValue(event.target.value);
  };

  const handleSelect = (address) => {
    setValue(address, false);
    clearSuggestions();
    getGeocode({ address })
      .then((results) => getLatLng(results[0]))
      .then((latLng) => {
        const { lat, lng } = latLng;
        panTo({ lat, lng });
      })
      .catch((error) => {
        console.error("Error:", error);
      });
    setShowSearch(false);
  };

  return (
    <>
      {loaded && (
        <SearchButton
          setSelected={setSelected}
          setShowMenu={setShowMenu}
          setShowSearch={setShowSearch}
        />
      )}
      {showSearch && (
        <div className="search">
          <Combobox onSelect={handleSelect}>
            <ComboboxInput
              className="search-input"
              disabled={!ready}
              onChange={handleChange}
              placeholder="Search for nearby cats"
              value={value}
              selectOnClick={true}
            />
            <ComboboxPopover>
              <ComboboxList>
                {status === "OK" &&
                  data.map(({ place_id, description }) => (
                    <ComboboxOption key={place_id} value={description} />
                  ))}
              </ComboboxList>
            </ComboboxPopover>
          </Combobox>
        </div>
      )}
    </>
  );
};

export default MapSearch;
